import BlockOffices from './offices'

export default BlockOffices
